import { useState } from 'react';

import { Modal as LegacyModal } from '@flipster/react/design-system-legacy/modal';
import { Modal } from '@flipster/react/design-system/modal';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import PositionModes from '@web/app/[locale]/(web)/_modal/TradeSettingsModal/Settings/PositionModes';

import OrderTutorialV2Content from './OrderTutorialV2Content';
import { ExistingUserTutorialItems, NewUserTutorialItems } from './constants';

interface Props {
  variant: 'full' | 'new-features';
  isOpen: boolean;
  onClose: () => void;
  onFinish: () => void;
  onExit: () => void;
}

const OrderTutorialV2Modal = ({ variant, isOpen, onClose, onFinish, onExit }: Props) => {
  const [step, setStep] = useState(0);
  const [contentType, setContentType] = useState<'tutorial' | 'position-modes'>('tutorial');

  const tutorialItems = (() => {
    switch (variant) {
      case 'full':
        return NewUserTutorialItems;
      case 'new-features':
        return ExistingUserTutorialItems;
      default:
        variant satisfies never;
        throw new Error('Unknown variant');
    }
  })();

  if (contentType === 'position-modes') {
    return (
      <LegacyModal isOpen={isOpen} onExit={onExit}>
        <LegacyModal.Close
          onClose={() => {
            setContentType('tutorial');
            segment.track(TradeEvent.TradingOnboardingExitClick, {
              title: 'Position modes',
              onboarding_page_num: step + 1,
            });
          }}
        />
        <PositionModes
          onBack={() => setContentType('tutorial')}
          onError={() => onClose()}
          onSuccess={() => setContentType('tutorial')}
        />
      </LegacyModal>
    );
  }

  return (
    <Modal.Root
      isOpen={isOpen}
      onClose={() => {
        onClose();
        segment.track(TradeEvent.TradingOnboardingExitClick, {
          title: tutorialItems[step].englishTitle,
          onboarding_page_num: step + 1,
        });
      }}
      onExit={onExit}
    >
      <OrderTutorialV2Content
        step={step}
        onStepChange={setStep}
        items={tutorialItems}
        onFinish={onFinish}
        onClickPositionModes={() => setContentType('position-modes')}
      />
    </Modal.Root>
  );
};

export default OrderTutorialV2Modal;
